import type {
  ContextDialogShellProps,
  TemplateContextMap,
  TemplateFunction,
  TemplateFunctionInvoker,
  TemplateResult,
} from 'Components/types';
import { usePopup } from 'Core/hooks/index';
import { cloneSafe } from 'Utils/components';
import { simpleHandler } from 'Utils/roleHandler';

import ShowResultsButton, { type ShowResultsButtonTemplateParams } from './showResultsButton';

export interface ContextDialogTemplateParams extends TemplateContextMap {
  close: () => void;
  isMobile: boolean;
  name: string;
  showResultsButton: TemplateFunctionInvoker<ShowResultsButtonTemplateParams>;
}

interface Props extends ContextDialogShellProps<ContextDialogTemplateParams> {
  name: string;
  closeOnClickOutside?: boolean;
}

export default function ContextDialog({
  context,
  name,
  template,
  closeOnClickOutside,
}: Props): TemplateResult {
  const { opened, popupParams, popupRoles, close } = usePopup(name, closeOnClickOutside);

  if (!opened) {
    return null;
  }

  const onClick = simpleHandler(popupRoles);
  const showResultsButton = (templ: TemplateFunction<ShowResultsButtonTemplateParams>) => (
    <ShowResultsButton close={close} template={templ} key="show-results-button" />
  );

  const component = template.call({
    ...context,
    ...popupParams,
    close,
    name,
    showResultsButton,
  });

  return cloneSafe(component, null, { onClick });
}
